import React from "react";
import { List, Tag, Button } from "antd";
import {
  InfoCircleOutlined,
  WhatsAppOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { useSystemPackagesQuery } from "../../Services";
import { MOBILE, WHATSAPP } from "../../Constant";
import { ResizableDrawer } from "..";

interface UpgradePlanDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const UpgradePlanDrawer: React.FC<UpgradePlanDrawerProps> = ({
  open,
  onClose,
}) => {
  const { data: packages = [], isLoading: packagesLoading } =
    useSystemPackagesQuery();

  return (
    <ResizableDrawer
      title="Upgrade Plan"
      open={open}
      onClose={onClose}
      width={400}
      destroyOnClose
    >
      <div className="flex flex-col gap-5 h-full justify-between">
        <div className="space-y-4">
          <p className="text-xs text-gray-500 leading-normal">
            Below are our available subscription packages. To change or upgrade
            your plan, please contact the system administrator.
          </p>

          <List
            loading={packagesLoading}
            dataSource={packages}
            renderItem={(item: any) => (
              <List.Item className="!py-3 flex items-center justify-between border-b border-gray-100 dark:border-zinc-800 last:border-0">
                <div className="pr-4">
                  <span className="font-semibold text-gray-800 dark:text-zinc-200 text-sm block">
                    {item.name}
                  </span>
                  {item.note && (
                    <span className="text-xs text-gray-400 dark:text-zinc-500 block mt-0.5">
                      {item.note}
                    </span>
                  )}
                </div>
                <Tag
                  color="purple"
                  className="!rounded-full font-semibold border-none !px-3 !py-0.5"
                >
                  {Number(item.price) > 0
                    ? `Rs. ${Number(item.price).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                    : "Free"}
                </Tag>
              </List.Item>
            )}
          />
        </div>

        <div className="space-y-3 bg-gray-50 dark:bg-zinc-850 p-4 rounded-2xl border border-gray-100 dark:border-zinc-800">
          <div className="flex gap-2">
            <InfoCircleOutlined className="text-amber-600 dark:text-amber-400 mt-0.5 text-xs font-semibold" />
            <span className="text-[11px] leading-relaxed text-gray-600 dark:text-zinc-400 font-medium">
              Plan assignment operations are managed by system administrators.
              Use the buttons below to easily connect and request a plan
              upgrade.
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3 mt-2">
            <Button
              type="primary"
              icon={<WhatsAppOutlined />}
              className="rounded-xl h-10 font-semibold text-xs bg-green-600 hover:bg-green-700 border-none flex items-center justify-center gap-1.5 shadow-sm shadow-green-500/10 text-white"
              onClick={() =>
                window.open(
                  `https://wa.me/${(WHATSAPP || "+94777123456").replace(/\D/g, "")}`,
                  "_blank",
                )
              }
            >
              WhatsApp
            </Button>
            <Button
              icon={<PhoneOutlined />}
              className="rounded-xl h-10 font-semibold text-xs border-gray-200 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-300 flex items-center justify-center gap-1.5 hover:border-indigo-500 hover:text-indigo-500 dark:hover:border-indigo-400 dark:hover:text-indigo-400"
              onClick={() =>
                window.open(`tel:${MOBILE || "+94777123456"}`, "_self")
              }
            >
              Call Support
            </Button>
          </div>
        </div>
      </div>
    </ResizableDrawer>
  );
};
